import { render, staticRenderFns } from "./TableContents.vue?vue&type=template&id=5d4f0ef5&"
import script from "./TableContents.vue?vue&type=script&lang=js&"
export * from "./TableContents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports